import { ReduxAction, SDKActionId, SDKActions } from '@pocketrn/client/dist/entity-sdk';

export const REDUCER_KEY = 'technician';
const ra = new ReduxAction(REDUCER_KEY);

export enum ActionKey { Provider = 'provider' }

export const technicianActionId = new SDKActionId(ra);
export const technicianActions = new SDKActions(technicianActionId);
